import React, { useEffect, useState } from 'react';
import columns from '../../../columns/account.jsx';
import { Form, Dropdown, Select, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Segmented from "../../../components/segmented/Segmented.jsx";
import { useSearchParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { GetAllMT5AccountApi, UpdateMT5AccountLeverageApi, UpdateMT5AccountPasswordApi, VerifyLoginPasswordApi, AddMT5AccountbalanceApi, GetAllAccountTypeApi, UpdateMT5AccountACtypeApi } from '../../../api/request/account.js';
import moment from 'moment/moment.js';
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import ConfirmationModal from '../../../components/modals/ConfirmationModal.jsx';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import toast from 'react-hot-toast';
import ReactPlayer from 'react-player'
import Trades from '../../../assets/Trades.jsx';
import Setting from '../../../assets/Setting.jsx';
import Eye from '../../../assets/Eye.jsx';
import CandleIcon from '../../../assets/user/CandleIcon.jsx';
import { handleApiError } from '../../../utils/handleApiError.js';
import { useResponsive } from '../../../hooks/useResponsive.js';
import AccountsCardList from './components/AccountsCardList.jsx';


export default function Accounts() {

  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const [leverageForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [actypeForm] = Form.useForm();
  const [balanceForm] = Form.useForm();
  const [loginPasswordForm] = Form.useForm();
  const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();
  const { userDetails } = useSelector(state => state.user);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('Live Account');
  const [acfilter, setAcfilter] = useState('Approved');
  const [data, setData] = useState([]);
  const [tutorials, setTutorials] = useState();
  const [accounts, setAccounts] = useState([]);
  const [isOpenactypedForm, setIsOpenactypedForm] = useState(false)
  const items = [
    { key: '1', label: (<div onClick={() => setIsOpenLeverageForm(true)}>Leverage Management</div>) },
    { key: '2', label: (<div onClick={() => setIsOpenPasswordForm(true)}>Change Password</div>) },
    { key: '3', label: (<div onClick={() => setIsOpenAddbalanceForm(true)}>Add Balance</div>) }
  ];

  const allitem = [
    { key: '1', label: (<div onClick={() => setIsOpenLeverageForm(true)}>Leverage Management</div>) },
    { key: '2', label: (<div onClick={() => setIsOpenPasswordForm(true)}>Change Password</div>) },
    // { key: '3', label: (<div onClick={() => setIsOpenactypedForm(true)}>Update A/C Type</div>) },
  ];
  const [leverageInitialValues, setLeverageInitialValues] = useState({ leverage: null });
  const [balanceInitialValues, setBalanceInitialValues] = useState({ balance: null });
  const [isOpenLeverageForm, setIsOpenLeverageForm] = useState(false);
  const [selectedLeverage, setSelectedLeverage] = useState(null);
  const [isOpenLeverageConfirm, setIsOpenLeverageConfirm] = useState(false);
  const [isLeverageFormLoading, setIsLeverageFormLoading] = useState(false);
  const [isbalanceFormLoading, setIsbalanceFormLoading] = useState(false);
  const [leverageOptions, setLeverageOptions] = useState([]);
  const [BalanceOptions, setBalanceOptions] = useState([20, 50, 100, 200, 300, 400, 500].map(num => ({ value: num, label: String(num) })));
  const [isOpenPasswordForm, setIsOpenPasswordForm] = useState(false);
  const [passwordInitialValues, setPasswordInitialValues] = useState({ pType: null, newPassword: '', confirmPassword: '' });
  const [actypeInitialValues, setActypeInitialValues] = useState({})
  const [loginPasswordInitialValues, setLoginPasswordInitialValues] = useState({ currentPassword: '' });
  const [isPasswordFormLoading, setIsPasswordFormLoading] = useState(false);
  const [isOpenPasswordConfirmationModal, setIsOpenPasswordConfirmationModal] = useState(false);
  const [isOpenactypedConfirmationModal, setIsOpenactypeConfirmationModal] = useState(false);
  const [isLoadingPasswordConfirmation, setIsLoadingPasswordConfirmation] = useState(false);
  const [passwordValue, setPasswordValue] = useState(null);
  const [actypeValue, setActypeValue] = useState(null)
  const [isOpenAddbalanceForm, setIsOpenAddbalanceForm] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [tutorialsdetails, setTutorialsdetails] = useState({});
  const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
  const [actype, setActype] = useState([]);
  let action = { title: 'Action', dataIndex: 'action' };

  const filterAccounts = (type) => {
    const isDemo = type === 'Demo Account';
    setAccounts(data.filter(account => account.isDemo === isDemo));
  };

  const getAccounts = async () => {
    try {
      let params = {
        FilterText: acfilter === 'Declined' ? 'Rejected' : acfilter,
      }
      setIsLoading(true);
      const { data } = await GetAllMT5AccountApi(filter === "Live Account", new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              originalStatus: item?.status, // Preserve original status for mobile card view
              status: (item?.status == 'Approved' ? (<span className='px-3 py-1 rounded-full uppercase text-xs text-center success_tag'>{item?.status}</span>) : (
                <span className='uppercase px-3 py-1 rounded-full text-xs text-center fail_tag'>{item?.status}</span>
              )),
              balances: `$ ${item?.balance?.toFixed(2)}`,
              createdAt: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
              action: (
                <div className='flex items-center gap-3'>
                  {item?.status == 'Approved' ? (
                    <Dropdown
                      menu={{ items: item.isDemo === true ? items : allitem }}
                      placement="bottomLeft"
                      arrow
                      trigger={['click']}
                    >
                      <div onClick={() => setSelectedAccount(item)} className='cursor-pointer'>
                        <Setting />
                      </div>
                    </Dropdown>
                  ) : null}

                  {/* {filter === "Live Account" ? (
                    <button onClick={() => navigate(`/trades/${item?.login}`)}>
                      <Trades />
                    </button>
                  ) : null} */}
                  <button onClick={() => navigate(`/accounts/${item?.login}`)}>
                    <CandleIcon />
                  </button>
                </div>
              )
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    filterAccounts(filter);
  }, [data]);

  useEffect(() => {
    setSearchParams(`filter=${filter}`);
    filterAccounts(filter);
  }, [filter]);

  useEffect(() => {
    leverageForm.resetFields();
    passwordForm.resetFields();
  }, [isOpenLeverageForm, isOpenPasswordForm]);

  useEffect(() => {
    loginPasswordForm.resetFields();
  }, [isOpenPasswordConfirmationModal]);

  const handleLeverageManagement = (values) => {
    setSelectedLeverage(values?.leverage)
    setIsOpenLeverageConfirm(true);
  }

  const updateLeverage = async () => {
    try {
      setIsLeverageFormLoading(true);
      let params = {
        leverage: selectedLeverage,
        loginId: selectedAccount?.login
      }
      const { data } = await UpdateMT5AccountLeverageApi(params);
      if (data?.success) {
        leverageForm.resetFields();
        getAccounts();
        setIsOpenLeverageForm(false);
        setIsOpenLeverageConfirm(false);
      }
      setIsLeverageFormLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsLeverageFormLoading(false);
    }
  }

  const updateActype = async () => {
    try {
      setIsPasswordFormLoading(true);
      let params = {
        ...actypeValue
      }
      const { data } = await UpdateMT5AccountACtypeApi(params);
      if (data?.success) {
        actypeForm.resetFields();
        getAccounts();
        setIsOpenactypedForm(false);
        setIsOpenactypeConfirmationModal(false);
      }
      setIsPasswordFormLoading(true);
    } catch (error) {
      handleApiError(error);
      setIsPasswordFormLoading(true);
    }
  }

  const AddbalanceForm = async (values) => {
    try {
      setIsbalanceFormLoading(true);
      let params = {
        ...values,
        loginId: selectedAccount?.login
      }
      const { data } = await AddMT5AccountbalanceApi(params);
      if (data?.success) {
        balanceForm.resetFields();
        toast.success(data?.message);
        getAccounts();
        setIsOpenAddbalanceForm(false);
      }
      setIsbalanceFormLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsbalanceFormLoading(false);
    }
  }

  const getAllTutorials = async () => {
    try {
      setIsLoading(true);
      let params = {
        tutorialType: "Accounts"
      }
      const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setTutorials(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (searchParams?.get('filter')) {
      setFilter(searchParams?.get('filter'));
    };
    // getAccounts();
    getAllTutorials()
    getContries();
  }, []);
  useEffect(() => {
    getAccounts();
  }, [filter, acfilter]);

  const handlePasswordUpdate = (values) => {
    setIsPasswordFormLoading(true);
    let params = {
      loginId: selectedAccount?.login,
      newPassword: values?.newPassword,
      pType: values?.pType
    }
    setPasswordValue(params);
    setIsOpenPasswordConfirmationModal(true);
  }

  const handleACtypeUpdate = (values) => {
    setIsPasswordFormLoading(true);
    let params = {
      loginId: selectedAccount?.login,
      planId: values?.pType,

    }
    setActypeValue(params);
    setIsOpenactypeConfirmationModal(true);
  }

  const verifyPassword = async (values) => {
    try {
      setIsLoadingPasswordConfirmation(true);
      const { data } = await VerifyLoginPasswordApi(values);
      if (data?.success) {
        setIsOpenPasswordConfirmationModal(false);
        setIsLoadingPasswordConfirmation(false);
        loginPasswordForm.resetFields();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      handleApiError(error);
      setIsLoadingPasswordConfirmation(false);
      return false;
    }
  }

  const handleLoginPassword = async (values) => {
    try {
      setIsPasswordFormLoading(true);
      if (await verifyPassword(values)) {
        const { data } = await UpdateMT5AccountPasswordApi(passwordValue);
        if (data?.success) {
          toast.success(data?.message);
          passwordForm.resetFields();
          setIsOpenPasswordForm(false);
        }
        setIsPasswordFormLoading(false);
      }
    } catch (error) {
      handleApiError(error);
      setIsPasswordFormLoading(false);
    }
  }

  const addTutorialsModalHandler = (Item) => {
    setIsOpenModaldetails(true);
    setTutorialsdetails(Item)
  }

  const getContries = async () => {
    try {
      let apiParams = {
        UserId: userDetails._id,
        AccountType: true
      }
      const { data } = await GetAllAccountTypeApi(new URLSearchParams(apiParams).toString());
      if (data?.success) {
        setActype(
          data?.data?.map((item) => ({
            ...item,
            value: item?.planId,
            label: item?.planName,
          }))
        );

      }
    } catch (error) { }
  };

  const LeverageOption = [1, 2, 3, 5, 10, 15, 20, 25, 33, 40, 50, 66, 75, 80, 100, 125, 150, 175, 200, 300, 400, 500, 1000, 5000];

  useEffect(() => {
    if (isOpenLeverageForm && selectedAccount?.maxLeverage) {
      const availableOptions = LeverageOption
        .filter(val => val <= selectedAccount.maxLeverage)
        .map(val => ({ value: val, label: String(val) }));
      setLeverageOptions(availableOptions);
    }
  }, [isOpenLeverageForm, selectedAccount]);

  return (
    <div>
      <div className='flex flex-wrap justify-between items-center sm:gap-5 gap-3'>
        <div className={`ant-select-selector-white w-full md:w-auto`}>
          <Segmented options={['Live Account', 'Demo Account']} value={filter} setValue={setFilter} block={isMobile} />
        </div>
        <div className='block w-full md:w-auto md:flex flex-wrap xl:px-2'>
          {filter === 'Live Account' ? (
            <div className={`ant-select-selector-white w-full md:w-auto`}>
              <Segmented options={['Approved', 'Pending', 'Declined']} value={acfilter} setValue={setAcfilter} block={isMobile} />
              <button
                className={`md:ms-3 md:mt-0 mt-3 text-sm text-white font-semibold px-4 rounded-lg themeHover duration-500 ${isMobile ? 'bg-primary py-3 w-full' : 'bg-primary py-2'}`}
                onClick={() => navigate('/account?type=live')}
              >
                Open Live Account
              </button>
            </div>
          ) : (
            <button
              className={`ms-3 md:mt-0 mt-3 text-sm text-white font-semibold px-4 rounded-lg themeHover duration-500 ${isMobile ? 'bg-primary py-3 w-full' : 'bg-primary py-2'}`}
              onClick={() => navigate('/account?type=demo')}
            >
              Open Demo Account
            </button>
          )}
        </div>
      </div>

      {/* Mobile Card View */}
      {isMobile ? (
        <AccountsCardList
          accounts={accounts}
          isLoading={isLoading}
          items={items}
          allitem={allitem}
          onAccountSelect={setSelectedAccount}
        />
      ) : (
        // Desktop Table View
        <div className='border border-gray-200 rounded-xl overflow-hidden bg-white my-6'>
          <TableWithSkeleton columns={[...columns, action]} data={accounts} loading={isLoading} />
        </div>
      )}

      {/* Leverage management form modal */}
      <ModalComponent isOpen={isOpenLeverageForm} setIsOpen={setIsOpenLeverageForm} title='Leverage Management'>
        <Form className='w-full' autoComplete="off" form={leverageForm} initialValues={leverageInitialValues} onFinish={handleLeverageManagement}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
            <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <button type='submit' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'>Proceed</button>
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenLeverageForm(false)}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Add balance form modal */}
      <ModalComponent isOpen={isOpenAddbalanceForm} setIsOpen={setIsOpenAddbalanceForm} title='Add balance'>
        <Form className='w-full' autoComplete="off" form={balanceForm} initialValues={balanceInitialValues} onFinish={AddbalanceForm}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Balance</label>
            <Form.Item name='amount' rules={[{ required: true, message: 'Please select balance.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select balance' options={BalanceOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            {/* <button type='submit' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'>Proceed</button> */}
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isbalanceFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isbalanceFormLoading}
              loadingLable='Updating amount...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenAddbalanceForm(false)}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Leverage confirmation modal */}
      <ConfirmationModal
        isOpen={isOpenLeverageConfirm}
        setIsOpen={setIsOpenLeverageConfirm}
        message={`${selectedLeverage > selectedAccount?.leverage ? `You have chosen 1:${selectedLeverage} leverage with a high-risk level.` : ''} Leverage will affect the required margin. Are you sure you want to continue?`}
        onConfirm={updateLeverage}
        isLoading={isLeverageFormLoading}
        loadingLabel='Changing Leverage...'
      />

      {/* Update A/C type confirmation modal */}
      <ConfirmationModal
        isOpen={isOpenactypedConfirmationModal}
        setIsOpen={setIsOpenactypeConfirmationModal}
        message=" Are you sure you want to Update A/C type?"
        onConfirm={updateActype}
        isLoading={isLeverageFormLoading}
        loadingLabel='Changing Leverage...'
      />

      {/* Update password form modal */}
      <ModalComponent isOpen={isOpenPasswordForm} setIsOpen={setIsOpenPasswordForm} title='Change Password'>
        <Form className='w-full' autoComplete="off" form={passwordForm} initialValues={passwordInitialValues} onFinish={handlePasswordUpdate}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Password Type</label>
            <Form.Item name='pType' rules={[{ required: true, message: 'Please select password type.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select password type' options={[{ value: 1, label: 'Change Investor Password' }, { value: 0, label: 'Change Trading Password' }]} />
            </Form.Item>
          </div>
          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>New Password</label>
            <Form.Item name='newPassword' hasFeedback rules={[{ required: true, message: 'Please enter new password.' }, {
              pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
              message: 'Please enter strong password.',
            },]}>
              <Input.Password type='password' placeholder="New password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Confirm Password</label>
            <Form.Item name='confirmPassword' dependencies={['newPassword']} hasFeedback rules={[{ required: true, message: 'Please enter confirm password.' }, ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The new password that you entered do not match!'));
              },
            }),]}>
              <Input.Password type='password' placeholder="Confirm password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isPasswordFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isPasswordFormLoading}
              loadingLable='Updating password...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenPasswordForm(false)} disabled={isPasswordFormLoading}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>


      {/* Update A/C Type form modal */}
      <ModalComponent isOpen={isOpenactypedForm} setIsOpen={setIsOpenactypedForm} title='Update A/C Type'>
        <Form className='w-full' autoComplete="off" form={actypeForm} initialValues={actypeInitialValues} onFinish={handleACtypeUpdate}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>A/C Type</label>
            <Form.Item name='pType' rules={[{ required: true, message: 'Please select A/C type.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select A/C type' options={actype} />
            </Form.Item>
          </div>

          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              // disabled={isPasswordFormLoading}
              type="Submit"
              lable='Proceed'
              // isLoading={isPasswordFormLoading}
              loadingLable='Updating A/C type...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenactypedForm(false)} disabled={isPasswordFormLoading}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Login password confirmation form modal */}
      <ModalComponent isOpen={isOpenPasswordConfirmationModal} setIsOpen={setIsOpenPasswordConfirmationModal} title='Verify login Password'>
        <Form className='w-full' autoComplete="off" form={loginPasswordForm} initialValues={loginPasswordInitialValues} onFinish={handleLoginPassword}>
          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Login Password</label>
            <Form.Item name='currentPassword' rules={[{ required: true, message: 'Please enter login password.' }]}>
              <Input.Password type='password' placeholder="Login password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isLoadingPasswordConfirmation}
              type="Submit"
              lable='Verify'
              isLoading={isLoadingPasswordConfirmation}
              loadingLable='Verifying password...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenPasswordConfirmationModal(false)} disabled={isLoadingPasswordConfirmation}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Tutorial' width={1000}>
        {tutorials && tutorials.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
            {tutorials?.map((item, index) => (
              <div
                key={index}
                className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
                onClick={() => addTutorialsModalHandler(item)}
              >
                <div className="relative pb-[56.25%] h-0">
                  {item.youtubeUrl ? (
                    <ReactPlayer
                      url={item.youtubeUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : item.videoUrl ? (
                    <ReactPlayer
                      url={item.videoUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : (
                    <p>Video not available</p>
                  )}
                </div>
                <div className="text-center p-4">
                  <p className="text-lg font-semibold line-limit-1">{tutorials?.title}</p>
                  <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorials?.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center'>
            <p className='text-lg font-semibold'>Video not available</p>
          </div>
        )}
      </ModalComponent>


      <ModalComponent isOpen={isOpenModaldetails} setIsOpen={setIsOpenModaldetails} title='Tutorial' width={800}>
        <div className="relative pb-[56.25%] h-0">

          {tutorialsdetails.youtubeUrl ? (
            <ReactPlayer
              url={tutorialsdetails.youtubeUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : tutorialsdetails.videoUrl ? (
            <ReactPlayer
              url={tutorialsdetails.videoUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : (
            <p>Video not available</p>
          )}

        </div>
        <div className="text-center p-4">
          <p className="text-lg font-semibold line-limit-1">{tutorialsdetails?.title}</p>
          <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorialsdetails?.description}</p>
        </div>
      </ModalComponent>
    </div>
  )
}

